import IsDebugChecker from '../is-debug/IsDebugChecker';
import Logger from './Logger';

export default new Logger(new IsDebugChecker());
